import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import annotateGlossaryTerms, { GlossaryIndex } from './utils/annotateGlossaryTerms';
import installGlossaryPopover from './glossaryPopover';
import { GLOSSARY_TAG_SLUG } from './components/GlossaryPage';
export const PREFERENCE_KEY = 'champis-others.glossaryTerms';
const CACHE_SIZE = 300;
let index = null;
let loading = false;
// Bumped when the terms arrive: the posts on screen are built again.
let version = 0;
const annotated = new Map();
function load() {
  if (loading) return;
  loading = true;
  app.request({
    method: 'GET',
    url: app.forum.attribute('apiUrl') + '/champis-glossary-terms',
    // Posts without their definitions are no error worth an alert.
    errorHandler: () => {}
  }).then(payload => {
    index = new GlossaryIndex(payload.data[0]?.attributes.terms ?? []);
    version++;
    m.redraw();
  }).catch(() => {});
}
function annotate(html, glossary) {
  let result = annotated.get(html);
  if (result === undefined) {
    if (annotated.size >= CACHE_SIZE) annotated.clear();
    result = annotateGlossaryTerms(html, glossary);
    annotated.set(html, result);
  }
  return result;
}

// Members can turn them off in their settings (addGlossaryTermsSetting.tsx);
// guests always see them.
export function glossaryTermsShown() {
  return app.session.user?.preferences()?.[PREFERENCE_KEY] !== false;
}

// A definition's own discussion, whose words are glossary terms all over.
function inGlossary(post) {
  const discussion = post.discussion();
  const tags = discussion?.tags?.();
  return Array.isArray(tags) && tags.some(tag => tag?.slug() === GLOSSARY_TAG_SLUG);
}

/**
 * The glossary's terms underlined in posts, first occurrence of each - the
 * technical ones (the everyday ones are excluded in the extension's
 * settings) - with their definition in a bubble (glossaryPopover.ts). Not
 * in a post being edited nor in search results (core's own highlighting
 * of the words searched).
 *
 * The terms load once, the first time a post is shown: until then, posts
 * show as they are, and are built again once they're here.
 */
export default function glossaryTerms() {
  installGlossaryPopover(id => index?.terms.get(id));
  extend('flarum/forum/components/CommentPost', 'oninit', function () {
    this.subtree.check(() => version);
  });
  extend('flarum/forum/components/CommentPost', 'content', function (items) {
    if (this.isEditing() || this.params?.q || !glossaryTermsShown() || inGlossary(this.attrs.post)) return;
    const comment = items.find(item => typeof item?.attrs?.contentHtml === 'string');
    if (!comment) return;
    if (!index) load();
    const html = index ? annotate(comment.attrs.contentHtml, index) : comment.attrs.contentHtml;

    // Built again with its terms: core runs a post's scripts again only when
    // the post itself changes - for the new DOM, the old one's are gone.
    if (this.champisGlossaryHtml !== undefined && this.champisGlossaryHtml !== html) this.contentHtml = null;
    this.champisGlossaryHtml = html;
    comment.attrs.contentHtml = html;
  });
}